import { render, staticRenderFns } from "./OnlyForEmployeesDialog.vue?vue&type=template&id=985fead2&"
import script from "./OnlyForEmployeesDialog.vue?vue&type=script&lang=js&"
export * from "./OnlyForEmployeesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports